module.exports = __webpack_public_path__ + "img/gg.06dc5b4a.png";